<template>
  <div class="file-uploader">
    <el-upload ref="upload"
               drag
               :class="['uploader', {'is-disabled': disabled, 'is-full': isFull}]"
               :list-type="listType"
               :action="getAction"
               :name="uploadName"
               :data="uploadParams"
               :accept="getAccept"
               :limit="getLimit"
               :before-upload="beforeUpload"
               :on-success="onUploadSuccess"
               :on-error="onUploadError"
               :on-change="onChange"
               :on-exceed="onExceed"
               :on-remove="onRemove"
               :http-request="httpRequest"
               :file-list="rawFileList"
               :disabled="disabled"
               v-bind="$attrs"
               v-on="$listeners">
      <slot>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
      </slot>
      <template #file="{file}">
        <slot name="file"
              :file="file"
              :remove="handleRemove">
        </slot>
      </template>
    </el-upload>
  </div>
</template>

<script>
import ElUpload from '../../mixins/upload/ElUpload'
export default {
  name: 'FileUploader',
  mixins: [ElUpload],
  props: {
    listType: {
      type: String,
      default: 'text'
    },
    fileList: Array,
    acceptTypes: Array,
    uploadAction: String,
    uploadName: {
      type: String,
      default: 'uploadFile'
    },
    uploadParams: Object,
    uploadCallback: {
      type: Function,
      default: data => data.uploadLink
    },
    uploadMultiple: Boolean,
    maxSize: Number,
    limit: Number,
    disabled: Boolean
  },
  data () {
    let fileList = (this.fileList || []).concat()
    return {
      rawFileList: this.uploadMultiple ? fileList : (fileList.length ? fileList.slice(0, 1) : [])
    }
  },
  computed: {
    getAction: function () {
      return this.$contextPath(this.uploadAction)
    },
    getAccept () {
      const acceptTypes = this.acceptTypes
      if (acceptTypes && acceptTypes.length) {
        return acceptTypes.join(',')
      }
    },
    getLimit () {
      if (this.uploadMultiple) {
        return this.limit
      } else {
        return 1
      }
    },
    isFull () {
      let limit = this.getLimit
      if (typeof limit === 'number' && limit > 0) {
        return this.rawFileList.length >= limit
      }
    }
  },
  methods: {
    beforeUpload (file) {
      const acceptTypes = this.acceptTypes
      if (acceptTypes && acceptTypes.length) {
        let filename = file.name
        let index = filename.lastIndexOf('.')
        if (index > 0) {
          let getType = filename.substring(index).toLowerCase()
          if (acceptTypes.every(type => type.toLowerCase() !== getType)) {
            this.$message.warning('上传格式不合法')
            return false
          }
        } else {
          this.$message.warning('上传格式不合法')
          return false
        }
      }
      if (typeof this.maxSize === 'number') {
        let isGt = file.size > this.maxSize
        if (isGt) {
          this.$message.warning('上传大小超过限制')
          return false
        }
      }
      return true
    },
    onUploadSuccess (res, file) {
      let url = this.uploadCallback(res)
      if (url) {
        file.url = url
      } else {
        file.url = ''
        this.$message.error(res['message'] || '返回结果为空')
      }
    },
    onUploadError () {
      this.$message.error('文件上传失败')
    },
    onChange (file, fileList) {
      this.rawFileList = fileList
    },
    onRemove (file, fileList) {
      this.rawFileList = fileList
    },
    onExceed () {
      this.$message.warning('上传数量超过限制')
    },
    handleRemove (file) {
      let upload = this.$refs.upload
      if (upload) {
        upload.handleRemove(file)
      }
    }
  },
  watch: {
    rawFileList: {
      handler (val) {
        let values
        if (val) {
          values = val.filter(v => !v.status || v.status === 'success').map(v => v.url).filter(url => !!url)
        } else {
          values = []
        }
        if (this.uploadMultiple) {
          this.$emit('input', values)
        } else {
          this.$emit('input', values[0] || '')
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .file-uploader {
    & > .uploader {
      * {
        transition: unset!important;
      }
      &.is-disabled,
      &.is-full {
        .el-upload {
          display: none;
        }
        .el-upload-list {
          .el-upload-list__item {
            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
      .el-upload {
        width: 100%;
        vertical-align: middle;
        &.el-upload--picture-card {
          width: 120px;
          height: 120px;
          border: none;
          line-height: 20px;
        }
        .el-upload-dragger {
          width: 100%;
          height: 120px;
          border-style: solid;
          border-radius: 4px;
          .el-icon-upload {
            margin-top: 26px;
            margin-bottom: 0;
            font-size: 36px;
            line-height: 30px;
          }
          .el-upload__text {
            padding: 5px;
            font-size: 12px;
            line-height: 140%;
          }
        }
      }
      .el-upload__tip {
        display: none;
      }
      .el-upload-list {
        &.el-upload-list--text {
          .el-upload-list__item {
            padding: 8px 10px;
            background-color: #fff;
            border: 1px solid #ebeef5;
            border-radius: 4px;
            .el-upload-list__item-name {
              font-size: 12px;
              i {
                font-size: 14px;
                vertical-align: -1px;
              }
            }
            .el-upload-list__item-status-label,
            .el-icon-close {
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
        &.el-upload-list--picture {
          .el-upload-list__item-name {
            font-size: 12px;
          }
        }
        &.el-upload-list--picture-card {
          .el-upload-list__item {
            margin-top: 0;
            width: 120px;
            height: 120px;
          }
        }
        .el-upload-list__item {
          margin-top: 8px;
          .el-progress {
            left: 0;
            right: 0;
            top: auto;
            bottom: 0;
          }
        }
      }
    }
  }
</style>
